import constant, {
  THEME_CONSTANTS,
  LIGHTTHEME,
  DARKTHEME,
  CUSTOMTHEME,
  CUSTOMBAR,
  DEFULTPAYMODES,
  DEFAULT_GRADIENT_COLOR,
  SmallButtonSize,
  MediumButtonSize,
  LargeButtonSize,
  QuickButton,
  DonateButton,
  customButton
} from '../utils/constants';
import { set } from './cache';
import { lightenDarkenColor, get } from './utility';
import { getObjectKey } from './getObjectKey';
import { numberWithoutCommas } from '../utils/utility';

const isWindowDefined = typeof window !== 'undefined';

let _getStaticPath = () => {
  let _url = STATIC_HOST;
  try {
    if (PROD) {
      _url += `/${PGP}/${VERSION}/${PLATFORM}`;
    }
  } catch (e) {}
  return _url;
};

/**
 * Get the Hosted Origin
 */
let _getIframeOrigin = () => {
  return IFRAME_ORIGIN;
};

/**
 * Get the running Environment
 */
let _getEnv = () => {
  return ENV;
};

let _parseData = (input = {}) => {
  initiateLogger('MerchantTemplateForm', (input.body && input.body.mid) || '', {
    FORM_TYPE: input.body && input.body.templateId ? 'EDIT_FORM' : 'CREATE_FORM'
  });
  let initialObj = {
    linkDescription: '',
    templateName: '',
    templateId: '',
    fields: [],
    givenFields: [],
    inDelible: {},
    isEdit: '',
    errorFieldName: '',
    displayedTooltip: '',
    displayedPopup: '',
    showSaveTemplateScreen: false,
    disableAddFieldButton: false,
    isEditTemplate: false
  };
  if (input) {
    let data = input.body;
    let customPlaceHolder = { name: constant.CUSTOM_DESC, type: constant.CUSTOM };
    let initialdropdownFields;

    if (_isNullOrUndefined(data.templateId) && data.mandatoryFields && data.mandatoryFields.length > 0) {
      initialObj.fields = data.mandatoryFields.map(field => {
        initialObj.inDelible[field.name] = true;
        return { ...field, mandatory: true };
      });
    }
    if (data.fields && data.fields.length > 0) {
      parseSuggestedField(data.fields);
      initialObj.fields = [...initialObj.fields, ...data.fields];
    }
    if (data.suggestedFields && data.suggestedFields.length > 0) {
      parseSuggestedField(data.suggestedFields);
      initialdropdownFields = data.suggestedFields.map(field => {
        initialObj.inDelible[field.name] = false;
        return field;
      });
    }

    if (data.templateInfo) {
      initialObj.linkDescription = data.templateInfo; // Setting linkDescription in Edit Form Case
    }

    if (data.templateName) {
      initialObj.templateName = data.templateName; // Setting templateName in Edit Form Case
    }

    if (data.templateId) {
      initialObj.isEditTemplate = true; // Checking for template create or edit
    }

    initialObj.customField = false; // Need to toggle from form to dropdown of fields and vice-versa
    initialObj.givenFields = [customPlaceHolder, ...initialdropdownFields];
    initialObj.addField = false;
    if (data.templateId) {
      initialObj.templateId = data.templateId;
    }
    set(constant.MID, data.mid);
    set(constant.TOKEN, data.token);
    initialObj.fields = parseAmountFields(initialObj.fields);
    return initialObj;
  }
};

const parseSuggestedField = fields => {
  fields.map(field => {
    if (field.hasOwnProperty('isEditable') && field.isEditable === false) {
      field.isSuggestedField = true;
    } else {
      field.isSuggestedField = false;
    }
    return field;
  });
};
/**
 * Need to group amount and non amount fields in order to support drag drop functionality
 * @param {fields} fields - passed fields
 */
const parseAmountFields = fields => {
  fields = fields || [];
  // fields other than amount
  let parsedFields = fields.filter(field => !isAmountField(field));
  // fields wiht amount
  parsedFields = parsedFields.concat(fields.filter(field => isAmountField(field)));

  return parsedFields;
};

/**
 * gets index of first amount field in the fields map
 * @param {options} options - passed fields
 */
const getAmountFieldFirstIndex = options => {
  let item;
  let lastIndex = -1;
  for (let index = 0; index < options.length; index++) {
    item = options[index];
    if (isAmountField(item)) {
      lastIndex = index;
      break;
    }
  }
  return lastIndex;
};

/**
 * Initiate the Logger with the MID and ENV Name
 * @param {String} envName - ENV Name ex `THEMATIC` or `CHECKOUT`
 * @param {String} mid - Merchant ID
 */
const initiateLogger = (envName, mid, others = {}) => {
  if (isWindowDefined) {
    const env = _getEnv();
    let pushEvent = window.UILogger;
    pushEvent &&
      pushEvent.init({
        debug: !(env === 'prod' || env === 'qa'),
        env: `${envName}_${env}`,
        MID: mid,
        ...others
      });
  }
};

/**
 * parse the APP_DATA
 * @param {Object} input  -  Incoming APP_DATA Object
 */
const _themeParse = (input = {}) => {
  initiateLogger('THEMATIC', (input.body && input.body.mid) || '');
  input = commonThemeCheckout(input, true);
  // isRedirectionTabSelected set to false
  input.isRedirectionTabSelected = false;
  input.isMobilePreviewSelected = false;
  set(constant.SAVEURL, constant.saveThemePreferences);
  return input;
};

/**
 * parse the APP_DATA
 * @param {Object} input  -  Incoming APP_DATA Object
 */
const _checkoutParse = (input = {}) => {
  initiateLogger('CHECKOUT', (input.body && input.body.mid) || '');
  // Dummy Paymodes
  input = commonThemeCheckout(input, false);
  input.isRedirectionTabSelected = false;
  input.isGenerateCodeStepEnabled = false;
  input.isMobilePreviewSelected = false;
  set(constant.SAVEURL, constant.saveCheckoutPreferences);
  return input;
};

/**
 * Convert into new Paymode, Display `Card` , for `Credit Card`, `Debit Card` or either
 * @param {Object} paymodes - Paymode Object
 */
const parsePaymodes = paymodes => {
  let newPaymodes = DEFULTPAYMODES;
  if (paymodes && Object.keys(paymodes).length > 0) {
    newPaymodes = [{ name: 'Paytm', type: constant.LOGIN, id: 1 }];
    for (const key in paymodes) {
      const { displayName, payMethod, recordId } = paymodes[key];
      let paymodeObj = { name: displayName, type: payMethod, id: recordId };
      newPaymodes.push(paymodeObj);
    }
  }
  return newPaymodes;
};

/**
 *
 * Update the Orderdered Paymodes, based on merchanct has added or removed the paymodes
 * @param {Object} orderedPaymodes - saved Ordered Paymodes
 * @param {Object} newPaymodes - New Paymodes
 */
const updatePaymodes = (orderedPaymodes, newPaymodes) => {
  let paymodes = [];
  if (newPaymodes && Object.keys(newPaymodes).length > 0) {
    // Remove the un-used paymodes
    // let isLogin = false;
    for (let paymode of orderedPaymodes) {
      if (paymode.type && newPaymodes[paymode.type]) {
        paymodes.push(paymode);
        newPaymodes[paymode.type].isUsed = true;
      }

      // if (!isLogin && paymode.type == constant.LOGIN) {
      //   isLogin = true
      //   paymodes.push({ name: 'Paytm', type: constant.LOGIN, id: 1 });
      // }
    }

    // if (!isLogin) {
    //   paymodes.unshift({ name: 'Paytm', type: constant.LOGIN, id: 1 });
    // }

    // Add the newly added paymodes by merchant
    for (const key in newPaymodes) {
      const { displayName, payMethod, recordId } = newPaymodes[key];
      if (newPaymodes[key] && !newPaymodes[key].isUsed) {
        let paymodeObj = { name: displayName, type: payMethod, id: recordId };
        paymodes.push(paymodeObj);
      }
    }
  }
  return paymodes || orderedPaymodes || DEFULTPAYMODES;
};

const addThemeProperty = (theme, isTheme = false) => {
  if (isTheme) {
    if (!get(theme, 'mobile.BORDER') && get(theme, 'mobile.HEADERPANEL')) {
      theme.mobile.BORDER = theme.mobile.HEADERPANEL;
    }

    if (!get(theme, 'web.BORDER') && get(theme, 'web.HEADERPANEL')) {
      theme.web.BORDER = theme.web.HEADERPANEL;
    }
  } else if (!get(theme, 'style.borderColor') && get(theme, 'style.headerBackgroundColor')) {
    theme.style.borderColor = theme.style.headerBackgroundColor;
  }
};

/**
 * Common logic for theme and checkout
 * @param {Object} input - Incoming APP_DATA Object
 */
const commonThemeCheckout = (input = {}, isThemeParse) => {
  if (
    input.body &&
    input.body.themePreferenceInfos &&
    input.body.themePreferenceInfos.CHECKOUT &&
    input.body.themePreferenceInfos.REDIRECTION
  ) {
    const { themePreferenceInfos, merchantPreferenceInfos, merchantPaymodesPreferenceOrder, mid, token, merchantLogoUrl } = input.body;

    const { REDIRECTION, CHECKOUT, isCustomPaymodeSelected, isGradientEffectEnable } = themePreferenceInfos;
    input.selected = REDIRECTION;
    input.CHECKOUT_THEME = CHECKOUT;
    input.token = token;
    input.isCustomPaymodeSelected = !!isCustomPaymodeSelected;

    if (themePreferenceInfos.hasOwnProperty('paytmLogo')) {
      input.onInvertImgLogo = themePreferenceInfos.paytmLogo !== constant.BLUE_LOGO;
    } else {
      input.onInvertImgLogo = false;
    }

    addThemeProperty(CHECKOUT);
    addThemeProperty(REDIRECTION, true);

    input.isGradientEffectEnable = isGradientEffectEnable !== false;
    if (
      isGradientEffectEnable !== true ||
      (get(REDIRECTION, 'gradient.buttonGradientsColors', []).length === 0 ||
        get(REDIRECTION, 'gradient.headerGradientsColors', []).length === 0)
    ) {
      input.selected.gradient = JSON.parse(JSON.stringify(DEFAULT_GRADIENT_COLOR));
      input.selected.gradient.buttonGradientsColors = [];
      input.selected.gradient.headerGradientsColors = [];
      input.selected.gradient.buttonGradientsColors.push(get(REDIRECTION, 'mobile.PAYBUTTONBG'));
      input.selected.gradient.buttonGradientsColors.push(lightenDarkenColor(get(REDIRECTION, 'mobile.PAYBUTTONBG')));
      input.selected.gradient.headerGradientsColors.push(get(REDIRECTION, 'mobile.HEADERPANEL'));
      input.selected.gradient.headerGradientsColors.push(lightenDarkenColor(get(REDIRECTION, 'mobile.HEADERPANEL')));
    }
    if (REDIRECTION && REDIRECTION.merchant) {
      input.isPaytmBrandingDisplay = REDIRECTION.merchant.hidePaytmBranding === false;
    } else {
      input.isPaytmBrandingDisplay = true;
    }
    
    if(!input.selected.merchant) { input.selected.merchant = {} }

    if((merchantLogoUrl === null) || 
      (merchantLogoUrl && merchantLogoUrl !== '' && (merchantLogoUrl.endsWith('.png') || merchantLogoUrl.endsWith('.jpg') || merchantLogoUrl.endsWith('.jpeg')))) {
      input.selected.merchant.merchantLogoUrl = merchantLogoUrl
    }

    // Enable Paytm Branding by Default. Reference: https://jira.mypaytm.com/browse/PGP-20733
    input.isPaytmBrandingDisplay = true;

    if (merchantPreferenceInfos.PG_AUTOLOGIN_ENABLED == 'N') {
      input.isAutoLoginSupported = false;
    } else {
      input.isAutoLoginSupported = true;
    }

    if (isThemeParse || merchantPreferenceInfos.THEMATIC_FEATURE_USED == 'Y') {
      input.isThematicFeatureUsed = true;
    } else {
      input.isThematicFeatureUsed = false;
    }

    if (merchantPreferenceInfos.IS_JSCHECKOUT_USED == 'Y') {
      input.isIntroductionPageVisible = false;
    } else {
      input.isIntroductionPageVisible = true;
    }

    if (merchantPreferenceInfos.IS_JSCHECKOUT_CODE_INTEGRATED == 'Y') {
      input.isJSCheckoutIntegrated = !!isThemeParse;
    } else if (isThemeParse) {
      if (merchantPreferenceInfos.IS_JSCHECKOUT_CODE_INTEGRATED == 'N') {
        input.isJSCheckoutIntegrated = true;
      } else {
        input.isJSCheckoutIntegrated = false;
      }
    } else {
      input.isJSCheckoutIntegrated = true;
    }

    input.isParentThemeOverwriteEnabled = !isThemeParse ? true : input.isJSCheckoutIntegrated;

    set(constant.TOKEN, token);
    set(constant.MID, mid);

    let customThemeMob = CUSTOMTHEME;
    let customThemeWeb = CUSTOMTHEME;

    if (input.selected.mobile && input.selected.mobile.NAME == THEME_CONSTANTS.CUSTOM) {
      customThemeMob = input.selected.mobile;
      customThemeWeb = input.selected.web;
    }
    if (REDIRECTION && REDIRECTION.payMode && REDIRECTION.payMode.order && REDIRECTION.payMode.order.length > 0) {
      if (merchantPaymodesPreferenceOrder) {
        input.merchantPayModes = updatePaymodes(REDIRECTION.payMode.order, merchantPaymodesPreferenceOrder);
      } else {
        input.merchantPayModes = REDIRECTION.payMode.order;
      }
    } else {
      input.merchantPayModes = parsePaymodes(merchantPaymodesPreferenceOrder);
    }
    if(input.merchantPayModes){
      input.merchantPayModes = input.merchantPayModes.filter(item => {
        return (
          item.type == constant.NB || item.type == constant.UPI || item.type == constant.CARD || item.type == constant.EMI
        );
      });
    }

    input.MobileTheme = { LIGHTTHEME, DARKTHEME, CUSTOMTHEME: customThemeMob };
    input.WebTheme = { LIGHTTHEME, DARKTHEME, CUSTOMTHEME: customThemeWeb };

    input.customBar = CUSTOMBAR;
    input.isMobilePreviewSelected = true;
    input.timestamp = new Date().getTime();
  } else {
    input.isError = true;
    input.errorMSG = 'Opps! Something went wrong (Invalid Data).';
  }

  return input;
};

let _preventDefault = event => {
  event.preventDefault();
  event.stopPropagation();
  return false;
};

/**
 * is value is `null` or `undefined`
 * @param {any} val - any value
 */
let _isNullOrUndefined = val => {
  return val === undefined || val === null;
};

/**
 * log the event type and values
 * @param {String} eventType - type of event
 * @param {String} value - event value
 * @param {String} otherObj - other object to log
 */
let _log = (eventType, value, otherObj = {}) => {
  let pushEvent = (window && window.UILogger) || undefined;
  pushEvent && pushEvent.log && pushEvent.log({ eventType: eventType, eventValue: value, ...otherObj });
};

const buttonTypes = [QuickButton, DonateButton], //customButton
  buttonSize = [SmallButtonSize, MediumButtonSize, LargeButtonSize],
  buttonTypeField = {
    placeholder: 'Button Type',
    type: 'Dropdown',
    constraints: {
      maxLength: '200',
      minLength: '3',
      allowedValues: buttonTypes
    },
    orientation: 'H',
    size: '100',
    isEditable: false,
    display: true
  },
  buttonTitleField = {
    placeholder: 'Button Title',
    type: 'Text',
    constraints: {
      maxLength: constant.SHORT_TEXT_MAX_CHAR,
      minLength: '3'
    },
    orientation: 'H',
    size: '100',
    isEditable: false
  },
  buttonStyleField = {
    placeholder: 'Button Style',
    type: 'ColorButton',
    orientation: 'H',
    size: '50',
    isEditable: false,
    display: true
  },
  buttonTextField = {
    placeholder: 'Button Font Color',
    type: 'ColorButton',
    orientation: 'H',
    size: '50',
    isEditable: false,
    display: true
  },
  buttonSizeField = {
    placeholder: 'Button Size',
    type: 'RadioInput',
    constraints: {
      maxLength: '200',
      minLength: '3',
      allowedValues: buttonSize
    },
    orientation: 'H',
    size: '100',
    isEditable: false,
    display: true
  },
  buttonPurposeField = {
    placeholder: 'Purpose of Payment',
    type: 'Text',
    hint: 'This will be shown to your customers when they make a payment',
    constraints: {
      maxLength: constant.SHORT_TEXT_MAX_CHAR,
      minLength: '3'
    },
    orientation: 'H',
    size: '100',
    isEditable: false,
    name: 'Purpose of Payment'
  };

const getButtons = () => {
  return {
    QUICK: {
      BUTTON: {
        type: 'QUICK',
        name: 'Quick-Pay Button',
        bgImage: 'quick-btn.png'
      },
      STEPS: {
        STEP1: {
          id: 1,
          name: 'Button Details',
          fields: {
            buttonType: buttonTypeField,
            buttonTitle: buttonTitleField,
            buttonStyle: buttonStyleField,
            buttonText: buttonTextField,
            buttonSize: buttonSizeField,
            buttonAmount: {
              placeholder: 'Add Your Amount',
              type: 'Amount',
              hint: 'Your customers will pay this amount to you',
              constraints: {
                maxLength: '10000000',
                minLength: '0'
              },
              orientation: 'H',
              size: '100',
              isEditable: false,
              name: 'Amount'
            },
            buttonPurpose: buttonPurposeField
          },
          nextStepButton: {
            placeholder: 'Proceed to Collect Customer Details',
            type: 'nextStepButton'
          }
        },
        STEP2: { id: 2, name: 'Collect Customer Details' },
        STEP3: { id: 3, name: 'Review Details' }
      }
    },
    DONATE: {
      BUTTON: {
        type: 'DONATE',
        name: 'Donate Button',
        bgImage: 'donate-btn.png'
      },
      STEPS: {
        STEP1: {
          id: 1,
          name: 'Button Details',
          fields: {
            buttonType: buttonTypeField,
            buttonTitle: buttonTitleField,
            buttonStyle: buttonStyleField,
            buttonText: buttonTextField,
            buttonSize: buttonSizeField,
            buttonPurpose: {
              ...buttonPurposeField,
              hint: 'This will be shown to your customers when they make a payment'
            }
          },
          nextStepButton: {
            placeholder: 'Proceed to Donation Amount',
            type: 'nextStepButton'
          }
        },
        STEP2: { id: 2, name: 'Donation Amount' },
        STEP3: { id: 3, name: 'Donor Details' },
        STEP4: { id: 4, name: 'Review Details' }
      }
    },
    // CUSTOM: {
    //   BUTTON: {
    //     type: 'CUSTOM',
    //     name: 'Custom Button',
    //     bgImage: 'custom-btn.png'
    //   },
    //   STEPS: {
    //     STEP1: {
    //       id: 1,
    //       name: 'Button Details',
    //       fields: {
    //         buttonType: buttonTypeField,
    //         buttonTitle: buttonTitleField,
    //         buttonStyle: buttonStyleField,
    //         buttonText: buttonTextField,
    //         buttonSize: buttonSizeField,
    //         buttonPurpose: {
    //           ...buttonPurposeField,
    //           hint: 'This will be shown to your customers when they make a payment'
    //         }
    //       },
    //       nextStepButton: {
    //         placeholder: 'Proceed to Amount \u0026 Customer Details',
    //         type: 'nextStepButton'
    //       }
    //     },
    //     STEP2: { id: 2, name: 'Amount \u0026 Customer Details' },
    //     STEP3: { id: 3, name: 'Review Details' }
    //   }
    // }
  };
};

const getSelectedButtonDetails = data => {
  if (getObjectKey(data, 'buttonDetails.buttonType')) {
    const buttonDetails = { ...getObjectKey(data, 'buttonDetails') };
    buttonDetails['buttonType'] = buttonTypes.filter(obj => obj.type === buttonDetails['buttonType'])[0] || QuickButton;
    buttonDetails['buttonSize'] =
      buttonSize.filter(obj => obj.type === buttonDetails['buttonSize'])[0] || LargeButtonSize;
    buttonDetails['buttonPurpose'] = getObjectKey(data, 'description');
    if (getObjectKey(data, 'amount', '')) {
      buttonDetails['buttonAmount'] = numberWithoutCommas(getObjectKey(data, 'amount', ''));
    }
    return buttonDetails;
  }
  return {};
};

const donateButtonDefaultFields = (data) => {
  const nameField = data.suggestedFields.filter(field => {
    if(field && (field.name === 'Full Name')){
      return field;
    }
  });

  const mobileField = data.suggestedFields.filter(field => {
    if(field && (field.name === 'Mobile Number')){
      return field;
    }
  });

  const emailField = {
    constraints: { maxLength: 200, minLength: 3 },
    displayText: '',
    helpText: '',
    isEditable: true,
    name: 'Email ID',
    orientation: 'H',
    size: '100',
    type: 'Text',
    mandatory: false
  };

  return [...nameField, emailField, ...mobileField];
  
}

const parsePaymentButton = (input = {}) => {
  initiateLogger('MerchantPaymentButton', (input && input.body && input.body.mid) || '', {
    BUTTON_TYPE: input && input.body && input.body.linkId ? 'EDIT_BUTTON' : 'CREATE_BUTTON'
  });
  const dataObject = { inDelible: {} };
  let data = input.body || {},
    customPlaceHolder = { name: constant['CUSTOM_DESC'], type: constant.CUSTOM },
    initialdropdownFields = [];

  if (data.suggestedFields && data.suggestedFields.length > 0) {
    parseSuggestedField(data.suggestedFields);
    initialdropdownFields = data.suggestedFields.map(field => {
      dataObject.inDelible[field.name] = false;
      return field;
    });
  } else {
    data['suggestedFields'] = [];
  }

  dataObject['donateDefaultFields'] = donateButtonDefaultFields(data);
  dataObject['paymentButtons'] = getButtons();
  dataObject['buttonConfig'] = getSelectedButtonDetails(data);
  dataObject['selectedButton'] = dataObject['buttonConfig']['buttonType'] || {};
  dataObject['activeStep'] = Object.keys(dataObject['buttonConfig']).length > 1 ? 'STEP1' : 'NONE';
  dataObject['fields'] = data.fields || [];
  dataObject['givenFields'] = [customPlaceHolder, ...initialdropdownFields];
  dataObject['displayedTooltip'] = '';
  dataObject['displayedPopup'] = '';
  dataObject['merchantInfo'] = {
    name: getObjectKey(data, 'merchantName', ''),
    logoURL: getObjectKey(data, 'logo', '')
  };
  dataObject['activeScreen'] = constant['BUTTON_SCREEN'];
  dataObject['customPaymentSuccessMessage'] = data.customPaymentSuccessMessage;
  dataObject['redirectionUrlFailure'] = data.redirectionUrlFailure;
  dataObject['redirectionUrlSuccess'] = data.redirectionUrlSuccess;
  dataObject['customFieldsValidationErrors'] = {};
  set(constant.MID, data.mid);
  set(constant.TOKEN, data.token);
  return dataObject;
};

const filterAmountFields = fields => {
  if (Array.isArray(fields)) {
    return fields.filter(field => isAmountField(field));
  }
  return [];
};

const filterInfoFields = fields => {
  if (Array.isArray(fields)) {
    return fields.filter(field => !isAmountField(field));
  }
  return [];
};

const isAmountField = field => {
  let fieldType = field && field.type;
  if (
    fieldType === constant['CUSTOM_AMOUNT_MERCHANT'] ||
    fieldType === constant['CUSTOM_AMOUNT_FLEXIBLE'] ||
    fieldType === constant['CUSTOM_AMOUNT_QUANTATIVE']
  ) {
    return true;
  }
  return false;
};

const isInputInvalid = function(value, min, max, type) {
  if (type === constant['TEXT']) {
    if (!value || (value && (value.length < min || value.length > max))) {
      return true;
    }
  } else if (type === constant['NUMBER']) {
    if (!value || (Number(value) && (Number(value) < min || Number(value) > max))) {
      return true;
    }
  } else if (type === constant.CUSTOM_AMOUNT_MERCHANT) {
    value = Number(value.replace(/[^0-9]/g, ''));
    if (isNaN(value) || value <= min || value >= max) {
      return true;
    }
  } else if (type === constant['URL']) {
    if (!value.match(constant['URL_REGEX'])) {
      return true;
    }
  }
  return false;
};

const parseHeaderData = input => {
  const data = {};
  if (input) {
    const isZeroAmount = (input.upfrontTxnAmount && Number(input.upfrontTxnAmount)) === 0;
    data.upFrontAmount = input.upfrontTxnAmount;
    data.isZeroAmount = isZeroAmount;
    data.payableAmount = isZeroAmount ? constant.SUBS_MIN_AMOUNT : input.upfrontTxnAmount;
    data.nextBilling = input.nextRenewalDate;
    data.merchantName = input.merchantName;
    data.mid = input.mid;
    data.logoURL = input.merchantLogo;
  }
  return data;
};

const parseSubscriptionData = input => {
  const data = {};
  if (input) {
    data.name = input.customerName;
    data.mobile = input.customerPhoneNo;
    data.email = input.customerEmail;
    data.planName = input.linkName;
    data.planDescription = input.linkDescription;
    data.frequency = input.frequencyUnit;
    data.nextBilling = input.nextRenewalDate;
    data.endDate = input.subscriptionEndDate;
    data.upFrontAmount = input.upfrontTxnAmount;
    data.planAmount = input.amountType === constant.AMOUNT_FIXED ? input.renewalAmount : input.maxAmount;
    data.renewalAmount = input.amountType === constant.AMOUNT_VARIABLE ? input.maxAmount : input.renewalAmount;
    data.amountType = input.amountType;
    data.subscriptionStatus = input.subscriptionStatus;
    data.trialPeriod = input.trialPeriod; // Number(input.trialPeriod);
    data.merchantDetails = { name: input.merchantName, mobile: input.merchantPhoneNo, email: input.merchantEmail };
  }
  return data;
};

const parseSubscriptionAppData = input => {
  const appData = JSON.parse(JSON.stringify(input));
  delete appData.customerPhoneNo;
  delete appData.customerEmail;
  delete appData.customerName;
  let paymentDetails = getObjectKey(appData, 'paymentDetails', []);
  for (let i = 0; i < paymentDetails.length; i++) {
    delete paymentDetails[i].customerMobileNo;
    delete paymentDetails[i].customerEmailId;
    delete paymentDetails[i].cardNo;
  }
  return appData;
};

const rupeeSymbol = () => {
  let rupee = '₹';
  if (typeof String.fromCodePoint === 'function') {
    rupee = String.fromCodePoint(0x20b9);
  }
  return rupee;
}

const getHeaderLogoUrl = (onInvertImgLogo, themeColor) => {
  let logo = '';
  if (THEME_CONSTANTS.DARK == themeColor.NAME) {
    logo = 'logo-white.svg';
  } else if (THEME_CONSTANTS.LIGHT == themeColor.NAME) {
    logo = 'logo-blue.svg';
  } else if (onInvertImgLogo) {
    logo = 'logo-white.svg';
  } else {
    logo = 'logo-blue.svg';
  }
  return `${_getStaticPath()}/assets/images/${logo}`;
};

export default {
  getStaticPath: _getStaticPath,
  getIframeOrigin: _getIframeOrigin,
  parseData: _parseData,
  preventDefault: _preventDefault,
  isNullOrUndefined: _isNullOrUndefined,
  log: _log,
  getEnv: _getEnv,
  isWindowDefined,
  themeParse: _themeParse,
  checkoutParse: _checkoutParse,
  getAmountFieldFirstIndex,
  initiateLogger,
  parsePaymentButton,
  filterAmountFields,
  filterInfoFields,
  isInputInvalid,
  parseAmountFields,
  isAmountField,
  parseHeaderData,
  parseSubscriptionData,
  parseSubscriptionAppData,
  rupeeSymbol,
  getHeaderLogoUrl
};



// WEBPACK FOOTER //
// ./common/common.js